export const dataU = {
  "id": 349,
  "name": "Recorrido Norte Norte - Upala",
  "name_es": "Recorrido Norte Norte - Upala",
  "name_en": "Recorrido Norte Norte - Upala",
  "explore_mode": false,
  "slug": "norte-upala",
  "sponsors": [],
  "guides": [],
  "active": false,
  "url": "http://localhost",
  "guide_img_id": "upalaguia",
  "transition_sound_id": null,
  "survey_code": "",
  "colors": [
    {
      "id": 989,
      "color": {
        "id": 1477,
        "primary": "#014f59",
        "secondary": "#61a830"
      },
      "order": 0
    },
    {
      "id": 990,
      "color": {
        "id": 1478,
        "primary": "#61a830",
        "secondary": "#014f59"
      },
      "order": 1
    },
    {
      "id": 991,
      "color": {
        "id": 1479,
        "primary": "#202945",
        "secondary": "#ffffff"
      },
      "order": 0
    },
    {
      "id": 992,
      "color": {
        "id": 1480,
        "primary": "#00f0a1",
        "secondary": "#202945"
      },
      "order": 1
    }
  ],
  "call_to_action": {
    "category": "Book",
    "mobile_redirect": "",
    "redirect": "",
    "promo_text": ""
  },
  "default_waypoint": {
    "scale": "1 1 1",
    "rig_rotation": "0 0",
    "text_color": "#202945",
    "text_scale": "1 1 1",
    "text_position": "1 1 1"
  },
  "lobby_rig_rotation": {
    "x": 0,
    "y": 0
  },
  "locations": [
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 617,
      "id": "",
      "order": 0,
      "name": "Souvenirs",
      "bg_id": "img-20230119-123609-00-010-pureshot-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_pajaros_s",
      "audio_id": "upala-souvenirs",
      "waypoints": [
        {
          "id_tour_creator": 880,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 7,
            "y_angle": 0,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Souvenirs 2",
          "text_es": "Souvenirs 2",
          "text_en": "Souvenirs 2",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 601,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 463,
          "has_info": false,
          "info": "En los últimos años, la región ha experimentado un aumento significativo en la actividad turística gracias a sus atractivos naturales y paisajes únicos. Este aumento ha generado una oportunidad de crecimiento económico para los negocios locales, quienes han sido capaces de ofrecer servicios de alta calidad a los visitantes. La inclusión de actividades recreativas, alojamiento, transporte y guías turísticos ha fortalecido la economía y mejorado la calidad de vida de la población local.",
          "info_es": "En los últimos años, la región ha experimentado un aumento significativo en la actividad turística gracias a sus atractivos naturales y paisajes únicos. Este aumento ha generado una oportunidad de crecimiento económico para los negocios locales, quienes han sido capaces de ofrecer servicios de alta calidad a los visitantes. La inclusión de actividades recreativas, alojamiento, transporte y guías turísticos ha fortalecido la economía y mejorado la calidad de vida de la población local.",
          "info_en": "En los últimos años, la región ha experimentado un aumento significativo en la actividad turística gracias a sus atractivos naturales y paisajes únicos. Este aumento ha generado una oportunidad de crecimiento económico para los negocios locales, quienes han sido capaces de ofrecer servicios de alta calidad a los visitantes. La inclusión de actividades recreativas, alojamiento, transporte y guías turísticos ha fortalecido la economía y mejorado la calidad de vida de la población local.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": -29,
            "distance": 7
          },
          "title": " ",
          "title_en": " ",
          "title_es": " ",
          "sound_id": null,
          "image_id": "img-20230119-123609-00-010-pureshot-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Souvenirs",
      "name_en": "Souvenirs",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 618,
      "id": "",
      "order": 5,
      "name": "Más de la Poza Natural Mapache",
      "bg_id": "img-20230120-125102-00-042-pureshot-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "rio_1_s",
      "audio_id": "upala-poza2correccion",
      "waypoints": [
        {
          "id_tour_creator": 896,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Restaurante",
          "text_es": "Restaurante",
          "text_en": "Restaurante",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 610,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 511,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": 25,
            "distance": 7
          },
          "title": "Poza Azul",
          "title_en": "Poza Azul",
          "title_es": "Poza Azul",
          "sound_id": null,
          "image_id": null,
          "icon_id": "videoicon",
          "video_url": "https://www.youtube.com/watch?v=DsmGI4cRA2U"
        },
        {
          "id_tour_creator": 496,
          "has_info": false,
          "info": "Durante nuestra visita, exploramos las espectaculares cataratas y disfrutamos de las tranquilas aguas termales en el pintoresco pueblo de Upala. Sin duda, es un lugar de ensueño para aquellos que buscan una experiencia única en armonía con la naturaleza.",
          "info_es": "Durante nuestra visita, exploramos las espectaculares cataratas y disfrutamos de las tranquilas aguas termales en el pintoresco pueblo de Upala. Sin duda, es un lugar de ensueño para aquellos que buscan una experiencia única en armonía con la naturaleza.",
          "info_en": "Durante nuestra visita, exploramos las espectaculares cataratas y disfrutamos de las tranquilas aguas termales en el pintoresco pueblo de Upala. Sin duda, es un lugar de ensueño para aquellos que buscan una experiencia única en armonía con la naturaleza.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": -31,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "img-20230120-125102-00-042-pureshot-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Más de la Poza Natural Mapache",
      "name_en": "Más de la Poza Natural Mapache",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 616,
      "id": "",
      "order": 3,
      "name": "Dos Ríos",
      "bg_id": "img-20230120-062357-00-018-pureshot-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_pajaros_s",
      "audio_id": "upala-dosrios",
      "waypoints": [
        {
          "id_tour_creator": 871,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 27,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Poza Mapache",
          "text_es": "Poza Mapache",
          "text_en": "Poza Mapache",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 604,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 465,
          "has_info": false,
          "info": "El Distrito de Dos Ríos es un importante punto dentro del Corredor Biológico que se extiende por varias regiones de Costa Rica, incluyendo Orosí, Cacao, Rincón de la Vieja, Miravalles y Tenorio. Este corredor es reconocido por su rica biodiversidad y su importancia ecológica, ya que conecta diferentes ecosistemas y permite el flujo de especies animales y vegetales entre ellos. De esta manera, el Distrito de Dos Ríos juega un papel fundamental en la conservación de la fauna y la flora de la región, y es un lugar de gran interés para aquellos que buscan experimentar la naturaleza de cerca.",
          "info_es": "El Distrito de Dos Ríos es un importante punto dentro del Corredor Biológico que se extiende por varias regiones de Costa Rica, incluyendo Orosí, Cacao, Rincón de la Vieja, Miravalles y Tenorio. Este corredor es reconocido por su rica biodiversidad y su importancia ecológica, ya que conecta diferentes ecosistemas y permite el flujo de especies animales y vegetales entre ellos. De esta manera, el Distrito de Dos Ríos juega un papel fundamental en la conservación de la fauna y la flora de la región, y es un lugar de gran interés para aquellos que buscan experimentar la naturaleza de cerca.",
          "info_en": "El Distrito de Dos Ríos es un importante punto dentro del Corredor Biológico que se extiende por varias regiones de Costa Rica, incluyendo Orosí, Cacao, Rincón de la Vieja, Miravalles y Tenorio. Este corredor es reconocido por su rica biodiversidad y su importancia ecológica, ya que conecta diferentes ecosistemas y permite el flujo de especies animales y vegetales entre ellos. De esta manera, el Distrito de Dos Ríos juega un papel fundamental en la conservación de la fauna y la flora de la región, y es un lugar de gran interés para aquellos que buscan experimentar la naturaleza de cerca.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 7,
            "y_angle": -37,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "img-20230120-062357-00-018-pureshot-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 455,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 5,
            "y_angle": -19,
            "distance": 7
          },
          "title": "Carretera",
          "title_en": "Carretera",
          "title_es": "Carretera",
          "sound_id": null,
          "image_id": "dsc-1170-1",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 553,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 15,
            "y_angle": 14,
            "distance": 7
          },
          "title": "Agutí centroamericano",
          "title_en": "Agutí centroamericano",
          "title_es": "Agutí centroamericano",
          "sound_id": null,
          "image_id": "dsc-1146",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 554,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "title": "Colibrí Garganta Negra",
          "title_en": "Colibrí Garganta Negra",
          "title_es": "Colibrí Garganta Negra",
          "sound_id": null,
          "image_id": "dsc-1225",
          "icon_id": null,
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Dos Ríos",
      "name_en": "Dos Ríos",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 603,
      "id": "",
      "order": 2,
      "name": "Entrada a Dos Rios",
      "bg_id": "img-20230119-123649-00-011-pureshot-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_pajaros_s",
      "audio_id": null,
      "waypoints": [
        {
          "id_tour_creator": 895,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Dos Ríos",
          "text_es": "Dos Ríos",
          "text_en": "Dos Ríos",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 616,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 526,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": -23,
            "distance": 7
          },
          "title": "Ganadería",
          "title_en": "Ganadería",
          "title_es": "Ganadería",
          "sound_id": null,
          "image_id": null,
          "icon_id": "videoicon",
          "video_url": "https://www.youtube.com/watch?v=40w0ekD45Vc"
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Entrada a Dos Rios",
      "name_en": "Entrada a Dos Rios",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 606,
      "id": "",
      "order": 10,
      "name": "Cruce Brasilia",
      "bg_id": "dsc-4223-panorama-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_autos_s",
      "audio_id": "upala-cruce",
      "waypoints": [
        {
          "id_tour_creator": 900,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": -32,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Cerro Cacao",
          "text_es": "Cerro Cacao",
          "text_en": "Cerro Cacao",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 602,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 468,
          "has_info": false,
          "info": "Carretera que conduce desde Santa Cecilia y Upala hacia la comunidad de Dos Ríos. Como punto de conexión de dos provincias Guanacaste y Alajuela. Dentro de este recorrido encontramos sembradíos de naranja, fincas ganaderas, bosques naturales y ríos de aguas cristalinas, también una gran variedad de aves\n",
          "info_es": "Carretera que conduce desde Santa Cecilia y Upala hacia la comunidad de Dos Ríos. Como punto de conexión de dos provincias Guanacaste y Alajuela. Dentro de este recorrido encontramos sembradíos de naranja, fincas ganaderas, bosques naturales y ríos de aguas cristalinas, también una gran variedad de aves\n",
          "info_en": "Carretera que conduce desde Santa Cecilia y Upala hacia la comunidad de Dos Ríos. Como punto de conexión de dos provincias Guanacaste y Alajuela. Dentro de este recorrido encontramos sembradíos de naranja, fincas ganaderas, bosques naturales y ríos de aguas cristalinas, también una gran variedad de aves\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -2,
            "y_angle": 39,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "dsc-4223-panorama-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Cruce Brasilia",
      "name_en": "Cruce Brasilia",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 601,
      "id": "",
      "order": 1,
      "name": "Dentro del establecimiento",
      "bg_id": "foto1",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_pajaros_s",
      "audio_id": "upala-souvenirs2",
      "waypoints": [
        {
          "id_tour_creator": 894,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Entrada a Dos Ríos",
          "text_es": "Entrada a Dos Ríos",
          "text_en": "Entrada a Dos Ríos",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 603,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 495,
          "has_info": false,
          "info": "Además, se ha promovido el turismo sostenible y responsable, permitiendo a los visitantes disfrutar de la naturaleza sin dañarla y promoviendo su conservación para futuras generaciones. Esta práctica turística responsable ha tenido un impacto positivo no solo en la economía local, sino también en la preservación del medio ambiente y en la promoción de la cultura local.",
          "info_es": "Además, se ha promovido el turismo sostenible y responsable, permitiendo a los visitantes disfrutar de la naturaleza sin dañarla y promoviendo su conservación para futuras generaciones. Esta práctica turística responsable ha tenido un impacto positivo no solo en la economía local, sino también en la preservación del medio ambiente y en la promoción de la cultura local.",
          "info_en": "Además, se ha promovido el turismo sostenible y responsable, permitiendo a los visitantes disfrutar de la naturaleza sin dañarla y promoviendo su conservación para futuras generaciones. Esta práctica turística responsable ha tenido un impacto positivo no solo en la economía local, sino también en la preservación del medio ambiente y en la promoción de la cultura local.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": 30,
            "distance": 7
          },
          "title": " ",
          "title_en": " ",
          "title_es": " ",
          "sound_id": null,
          "image_id": "foto1",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Dentro del establecimiento",
      "name_en": "Dentro del establecimiento",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 608,
      "id": "",
      "order": 8,
      "name": "Finca Integral",
      "bg_id": "img-20230120-064000-00-024-pureshot-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "bosque_ambiente_s",
      "audio_id": "upala-integral",
      "waypoints": [
        {
          "id_tour_creator": 898,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": -112,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Cerro Santa María",
          "text_es": "Cerro Santa María",
          "text_en": "Cerro Santa María",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 609,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 454,
          "has_info": false,
          "info": "Las mariposas Morpho Azul también tienen otras características interesantes. Por ejemplo, tienen patas muy delgadas que les permiten caminar sobre superficies como hojas y ramitas sin doblarlas o quebrarlas. También tienen una trompa larga y delgada que les permite succionar el néctar de las flores.\n",
          "info_es": "Las mariposas Morpho Azul también tienen otras características interesantes. Por ejemplo, tienen patas muy delgadas que les permiten caminar sobre superficies como hojas y ramitas sin doblarlas o quebrarlas. También tienen una trompa larga y delgada que les permite succionar el néctar de las flores.\n",
          "info_en": "Las mariposas Morpho Azul también tienen otras características interesantes. Por ejemplo, tienen patas muy delgadas que les permiten caminar sobre superficies como hojas y ramitas sin doblarlas o quebrarlas. También tienen una trompa larga y delgada que les permite succionar el néctar de las flores.\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": -29,
            "distance": 7
          },
          "title": "Mariposa Morpho 2",
          "title_en": "Mariposa Morpho 2",
          "title_es": "Mariposa Morpho 2",
          "sound_id": null,
          "image_id": "dsc-1312",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 451,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": 53,
            "distance": 7
          },
          "title": "Mariposa Morpho",
          "title_en": "Mariposa Morpho",
          "title_es": "Mariposa Morpho",
          "sound_id": null,
          "image_id": "dsc-1306",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 466,
          "has_info": false,
          "info": "Gama de comidas elaboradas con productos orgánicos donde se aprovechan los desechos del ganado para alimentar los biodigestores que producen gas, abono y foliores para ser usados en la producción de huertos orgánicos, brindando una alimentación sana para la comunidad y visitantes. También funcionan como fincas escuela que permite enseñarles estas características a los visitantes.",
          "info_es": "Gama de comidas elaboradas con productos orgánicos donde se aprovechan los desechos del ganado para alimentar los biodigestores que producen gas, abono y foliores para ser usados en la producción de huertos orgánicos, brindando una alimentación sana para la comunidad y visitantes. También funcionan como fincas escuela que permite enseñarles estas características a los visitantes.",
          "info_en": "Gama de comidas elaboradas con productos orgánicos donde se aprovechan los desechos del ganado para alimentar los biodigestores que producen gas, abono y foliores para ser usados en la producción de huertos orgánicos, brindando una alimentación sana para la comunidad y visitantes. También funcionan como fincas escuela que permite enseñarles estas características a los visitantes.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 26,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "img-20230120-064000-00-024-pureshot-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 453,
          "has_info": false,
          "info": "La Papilio palinurus es una especie de mariposa muy llamativa, con su coloración verde brillante y sus reflejos de colores. Además, presenta una cola bifurcada en la parte posterior de sus alas posteriores que le da una apariencia similar a la de un ave.",
          "info_es": "La Papilio palinurus es una especie de mariposa muy llamativa, con su coloración verde brillante y sus reflejos de colores. Además, presenta una cola bifurcada en la parte posterior de sus alas posteriores que le da una apariencia similar a la de un ave.",
          "info_en": "La Papilio palinurus es una especie de mariposa muy llamativa, con su coloración verde brillante y sus reflejos de colores. Además, presenta una cola bifurcada en la parte posterior de sus alas posteriores que le da una apariencia similar a la de un ave.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "title": "Mariposa Esmeralda",
          "title_en": "Mariposa Esmeralda",
          "title_es": "Mariposa Esmeralda",
          "sound_id": null,
          "image_id": "dsc-1277",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 452,
          "has_info": false,
          "info": "Además de su belleza, la mariposa tigre es conocida por su hábito de alimentarse de plantas tóxicas como la Adelfa, que contienen cardenólidos que son venenosos para muchos otros animales. Sin embargo, estas mariposas han desarrollado una resistencia a los efectos de los cardenólidos y los utilizan para su defensa contra los depredadores. De hecho, los colores brillantes de su cuerpo y alas pueden ser una señal visual de su toxicidad para los depredadores.",
          "info_es": "Además de su belleza, la mariposa tigre es conocida por su hábito de alimentarse de plantas tóxicas como la Adelfa, que contienen cardenólidos que son venenosos para muchos otros animales. Sin embargo, estas mariposas han desarrollado una resistencia a los efectos de los cardenólidos y los utilizan para su defensa contra los depredadores. De hecho, los colores brillantes de su cuerpo y alas pueden ser una señal visual de su toxicidad para los depredadores.",
          "info_en": "Además de su belleza, la mariposa tigre es conocida por su hábito de alimentarse de plantas tóxicas como la Adelfa, que contienen cardenólidos que son venenosos para muchos otros animales. Sin embargo, estas mariposas han desarrollado una resistencia a los efectos de los cardenólidos y los utilizan para su defensa contra los depredadores. De hecho, los colores brillantes de su cuerpo y alas pueden ser una señal visual de su toxicidad para los depredadores.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": -54,
            "distance": 7
          },
          "title": "Mariposa Tigre",
          "title_en": "Mariposa Tigre",
          "title_es": "Mariposa Tigre",
          "sound_id": null,
          "image_id": "dsc-1302",
          "icon_id": null,
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Finca Integral",
      "name_en": "Finca Integral",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 605,
      "id": "",
      "order": 7,
      "name": "Fincas",
      "bg_id": "img-20230120-062658-00-019-pureshot-panoramafinal-1",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "bosque_ambiente_s",
      "audio_id": "upala-finca",
      "waypoints": [
        {
          "id_tour_creator": 876,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Finca Integral",
          "text_es": "Finca Integral",
          "text_en": "Finca Integral",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 608,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 448,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -2,
            "y_angle": -36,
            "distance": 7
          },
          "title": "Ganado",
          "title_en": "Ganado",
          "title_es": "Ganado",
          "sound_id": null,
          "image_id": "dsc-1416-1",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 446,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -3,
            "y_angle": -81,
            "distance": 7
          },
          "title": "Caballos",
          "title_en": "Caballos",
          "title_es": "Caballos",
          "sound_id": null,
          "image_id": "dsc-1390",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 464,
          "has_info": false,
          "info": "Vivir la experiencia del turismo rural comunitario es una oportunidad inigualable para sumergirse en la vida cotidiana de las comunidades locales y conocer su forma de vida y tradiciones. Además, este tipo de turismo ofrece la posibilidad de disfrutar de la belleza natural de los destinos, lo que lo convierte en una experiencia completa y enriquecedora.",
          "info_es": "Vivir la experiencia del turismo rural comunitario es una oportunidad inigualable para sumergirse en la vida cotidiana de las comunidades locales y conocer su forma de vida y tradiciones. Además, este tipo de turismo ofrece la posibilidad de disfrutar de la belleza natural de los destinos, lo que lo convierte en una experiencia completa y enriquecedora.",
          "info_en": "Vivir la experiencia del turismo rural comunitario es una oportunidad inigualable para sumergirse en la vida cotidiana de las comunidades locales y conocer su forma de vida y tradiciones. Además, este tipo de turismo ofrece la posibilidad de disfrutar de la belleza natural de los destinos, lo que lo convierte en una experiencia completa y enriquecedora.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": 72,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "img-20230120-062658-00-019-pureshot-panoramafinal-1",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 447,
          "has_info": false,
          "info": "La ganadería en Upala se realiza en fincas dedicadas a la actividad, y suelen ser de tamaño pequeño y mediano. La producción ganadera se centra en la producción de leche y carne, que se comercializa tanto en la región como en otros lugares del país. Los métodos de producción varían, pero en general se realizan prácticas tradicionales y se utilizan pastos naturales para alimentar al ganado. La ganadería en Upala ha sido fuertemente afectada por la sequía y otros fenómenos climáticos, lo que ha llevado a la adopción de prácticas más sostenibles para hacer frente a estos desafíos.",
          "info_es": "La ganadería en Upala se realiza en fincas dedicadas a la actividad, y suelen ser de tamaño pequeño y mediano. La producción ganadera se centra en la producción de leche y carne, que se comercializa tanto en la región como en otros lugares del país. Los métodos de producción varían, pero en general se realizan prácticas tradicionales y se utilizan pastos naturales para alimentar al ganado. La ganadería en Upala ha sido fuertemente afectada por la sequía y otros fenómenos climáticos, lo que ha llevado a la adopción de prácticas más sostenibles para hacer frente a estos desafíos.",
          "info_en": "La ganadería en Upala se realiza en fincas dedicadas a la actividad, y suelen ser de tamaño pequeño y mediano. La producción ganadera se centra en la producción de leche y carne, que se comercializa tanto en la región como en otros lugares del país. Los métodos de producción varían, pero en general se realizan prácticas tradicionales y se utilizan pastos naturales para alimentar al ganado. La ganadería en Upala ha sido fuertemente afectada por la sequía y otros fenómenos climáticos, lo que ha llevado a la adopción de prácticas más sostenibles para hacer frente a estos desafíos.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": 53,
            "distance": 7
          },
          "title": "Ganadería",
          "title_en": "Ganadería",
          "title_es": "Ganadería",
          "sound_id": null,
          "image_id": "dsc-1440",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 527,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": 29,
            "distance": 7
          },
          "title": "Finca de Upala",
          "title_en": "Finca de Upala",
          "title_es": "Finca de Upala",
          "sound_id": null,
          "image_id": null,
          "icon_id": "videoicon",
          "video_url": "https://www.youtube.com/watch?v=3M6IqTeaxvw"
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Fincas",
      "name_en": "Fincas",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 610,
      "id": "",
      "order": 6,
      "name": "Restaurante",
      "bg_id": "foto6",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_pajaros_s",
      "audio_id": "upala-restaurante",
      "waypoints": [
        {
          "id_tour_creator": 897,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -3,
            "y_angle": -90,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Fincas",
          "text_es": "Fincas",
          "text_en": "Fincas",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 605,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 462,
          "has_info": false,
          "info": "El creciente auge del turismo ha propiciado el surgimiento de muchos emprendimientos. Uno de ellos es el turismo rural comunitario, que ofrece una experiencia única en la que se comparte con las familias y la comunidad. Este tipo de turismo se desarrolla en destinos con múltiples atractivos naturales, permitiendo a los visitantes experimentar de primera mano las actividades y la cultura locales.",
          "info_es": "El creciente auge del turismo ha propiciado el surgimiento de muchos emprendimientos. Uno de ellos es el turismo rural comunitario, que ofrece una experiencia única en la que se comparte con las familias y la comunidad. Este tipo de turismo se desarrolla en destinos con múltiples atractivos naturales, permitiendo a los visitantes experimentar de primera mano las actividades y la cultura locales.",
          "info_en": "El creciente auge del turismo ha propiciado el surgimiento de muchos emprendimientos. Uno de ellos es el turismo rural comunitario, que ofrece una experiencia única en la que se comparte con las familias y la comunidad. Este tipo de turismo se desarrolla en destinos con múltiples atractivos naturales, permitiendo a los visitantes experimentar de primera mano las actividades y la cultura locales.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "foto6",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Restaurante",
      "name_en": "Restaurante",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 609,
      "id": "",
      "order": 9,
      "name": "Camino a Cerro Santa María",
      "bg_id": "dsc-4363-panorama-panoramafinal-12",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": "upala-santam",
      "waypoints": [
        {
          "id_tour_creator": 899,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -9,
            "y_angle": -23,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Cruce Brasilia",
          "text_es": "Cruce Brasilia",
          "text_en": "Cruce Brasilia",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 606,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 457,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 7,
            "y_angle": -102,
            "distance": 7
          },
          "title": "Arbol",
          "title_en": "Arbol",
          "title_es": "Arbol",
          "sound_id": null,
          "image_id": "dsc-1167",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 497,
          "has_info": false,
          "info": "El Cerro Santa María es un imponente pico de 1.053 metros de altura que se encuentra en Costa Rica, cerca del majestuoso Volcán Rincón de la Vieja. Este cerro separa la hermosa región de Upala de la vibrante provincia de Guanacaste. Si buscas una aventura en la naturaleza y una vista espectacular de la región circundante, explorar el Cerro Santa María es una experiencia imprescindible.\nCon su imponente altura, el Cerro Santa María es un lugar que te dejará sin aliento.",
          "info_es": "El Cerro Santa María es un imponente pico de 1.053 metros de altura que se encuentra en Costa Rica, cerca del majestuoso Volcán Rincón de la Vieja. Este cerro separa la hermosa región de Upala de la vibrante provincia de Guanacaste. Si buscas una aventura en la naturaleza y una vista espectacular de la región circundante, explorar el Cerro Santa María es una experiencia imprescindible.\nCon su imponente altura, el Cerro Santa María es un lugar que te dejará sin aliento.",
          "info_en": "El Cerro Santa María es un imponente pico de 1.053 metros de altura que se encuentra en Costa Rica, cerca del majestuoso Volcán Rincón de la Vieja. Este cerro separa la hermosa región de Upala de la vibrante provincia de Guanacaste. Si buscas una aventura en la naturaleza y una vista espectacular de la región circundante, explorar el Cerro Santa María es una experiencia imprescindible.\nCon su imponente altura, el Cerro Santa María es un lugar que te dejará sin aliento.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": 18,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "dsc-4363-panorama-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 444,
          "has_info": false,
          "info": "El Volcán Santa María se encuentra en la Cordillera Volcánica de Guanacaste, a una altitud de 1.916 metros sobre el nivel del mar. Está situado al sureste del macizo del Rincón de la Vieja. El cráter de este volcán contiene una laguna de 2,5 hectáreas rodeada de una densa vegetación húmeda que acumula la abundante precipitación que prevalece en la zona. Desde este lugar, en un día despejado, se pueden apreciar el lago de Nicaragua, el golfo de Santa Elena y la bahía Culebra.",
          "info_es": "El Volcán Santa María se encuentra en la Cordillera Volcánica de Guanacaste, a una altitud de 1.916 metros sobre el nivel del mar. Está situado al sureste del macizo del Rincón de la Vieja. El cráter de este volcán contiene una laguna de 2,5 hectáreas rodeada de una densa vegetación húmeda que acumula la abundante precipitación que prevalece en la zona. Desde este lugar, en un día despejado, se pueden apreciar el lago de Nicaragua, el golfo de Santa Elena y la bahía Culebra.",
          "info_en": "El Volcán Santa María se encuentra en la Cordillera Volcánica de Guanacaste, a una altitud de 1.916 metros sobre el nivel del mar. Está situado al sureste del macizo del Rincón de la Vieja. El cráter de este volcán contiene una laguna de 2,5 hectáreas rodeada de una densa vegetación húmeda que acumula la abundante precipitación que prevalece en la zona. Desde este lugar, en un día despejado, se pueden apreciar el lago de Nicaragua, el golfo de Santa Elena y la bahía Culebra.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 6,
            "y_angle": -37,
            "distance": 7
          },
          "title": "Cerro Santa María",
          "title_en": "Cerro Santa María",
          "title_es": "Cerro Santa María",
          "sound_id": null,
          "image_id": "dsc-1181",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 552,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "title": "Ratonero de cola roja",
          "title_en": "Ratonero de cola roja",
          "title_es": "Ratonero de cola roja",
          "sound_id": null,
          "image_id": "dsc-1443",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 456,
          "has_info": false,
          "info": "El volcán Rincón de la Vieja es un volcán activo en la provincia de Guanacaste, en el noroeste de Costa Rica. Es parte del Parque Nacional Rincón de la Vieja, que abarca una superficie de 34,000 hectáreas y cuenta con numerosos senderos para caminar, hermosas cascadas y atractivos turísticos.",
          "info_es": "El volcán Rincón de la Vieja es un volcán activo en la provincia de Guanacaste, en el noroeste de Costa Rica. Es parte del Parque Nacional Rincón de la Vieja, que abarca una superficie de 34,000 hectáreas y cuenta con numerosos senderos para caminar, hermosas cascadas y atractivos turísticos.",
          "info_en": "El volcán Rincón de la Vieja es un volcán activo en la provincia de Guanacaste, en el noroeste de Costa Rica. Es parte del Parque Nacional Rincón de la Vieja, que abarca una superficie de 34,000 hectáreas y cuenta con numerosos senderos para caminar, hermosas cascadas y atractivos turísticos.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 13,
            "y_angle": -56,
            "distance": 7
          },
          "title": "Volcán Rincón de la Vieja",
          "title_en": "Volcán Rincón de la Vieja",
          "title_es": "Volcán Rincón de la Vieja",
          "sound_id": null,
          "image_id": "dsc-1176",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 525,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": -72,
            "distance": 7
          },
          "title": "Volcán Rincón de la Vieja Aerea",
          "title_en": "Volcán Rincón de la Vieja Aerea",
          "title_es": "Volcán Rincón de la Vieja Aerea",
          "sound_id": null,
          "image_id": null,
          "icon_id": "videoicon",
          "video_url": "https://www.youtube.com/watch?v=VJtcrUHxH0g"
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Camino a Cerro Santa María",
      "name_en": "Camino a Cerro Santa María",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 602,
      "id": "",
      "order": 11,
      "name": "Cerro Cacao",
      "bg_id": "dsc-4359-panorama-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_pajaros_s",
      "audio_id": "upala-cacao",
      "waypoints": [
        {
          "id_tour_creator": 901,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -3,
            "y_angle": 53,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Regresar",
          "text_es": "Regresar",
          "text_en": "Regresar",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 617,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 467,
          "has_info": false,
          "info": "El cerro tiene una altitud de 1699 metros y se encuentra ubicado en la frontera entre las provincias de Guanacaste y Alajuela. Rodeado de exuberante naturaleza, el lugar es un paraíso para los amantes de la flora y fauna. Además, ofrece impresionantes vistas panorámicas y se pueden apreciar sembradíos de naranja.\nLa zona es hogar de varias nacientes de ríos, como La Quebrada Mechos, río Cucorocho y La Palma, los cuales se unen para formar el río Pizote que desemboca en el lago. El río Pizote es conocido por sus cristalinas aguas y es un destino popular para los amantes de la naturales.\nEn definitiva, el cerro es un lugar de belleza natural incomparable, que ofrece una experiencia única para aquellos que buscan disfrutar de la naturaleza y explorar la región.",
          "info_es": "El cerro tiene una altitud de 1699 metros y se encuentra ubicado en la frontera entre las provincias de Guanacaste y Alajuela. Rodeado de exuberante naturaleza, el lugar es un paraíso para los amantes de la flora y fauna. Además, ofrece impresionantes vistas panorámicas y se pueden apreciar sembradíos de naranja.\nLa zona es hogar de varias nacientes de ríos, como La Quebrada Mechos, río Cucorocho y La Palma, los cuales se unen para formar el río Pizote que desemboca en el lago. El río Pizote es conocido por sus cristalinas aguas y es un destino popular para los amantes de la naturales.\nEn definitiva, el cerro es un lugar de belleza natural incomparable, que ofrece una experiencia única para aquellos que buscan disfrutar de la naturaleza y explorar la región.",
          "info_en": "El cerro tiene una altitud de 1699 metros y se encuentra ubicado en la frontera entre las provincias de Guanacaste y Alajuela. Rodeado de exuberante naturaleza, el lugar es un paraíso para los amantes de la flora y fauna. Además, ofrece impresionantes vistas panorámicas y se pueden apreciar sembradíos de naranja.\nLa zona es hogar de varias nacientes de ríos, como La Quebrada Mechos, río Cucorocho y La Palma, los cuales se unen para formar el río Pizote que desemboca en el lago. El río Pizote es conocido por sus cristalinas aguas y es un destino popular para los amantes de la naturales.\nEn definitiva, el cerro es un lugar de belleza natural incomparable, que ofrece una experiencia única para aquellos que buscan disfrutar de la naturaleza y explorar la región.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "dsc-4359-panorama-panoramafinal",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Cerro Cacao",
      "name_en": "Cerro Cacao",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 604,
      "id": "",
      "order": 4,
      "name": "Poza Natural Mapache",
      "bg_id": "pozanatural",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "rio_1_s",
      "audio_id": "upala-poza1",
      "waypoints": [
        {
          "id_tour_creator": 881,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 13,
            "y_angle": -720,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Más de la Poza Natural",
          "text_es": "Más de la Poza Natural",
          "text_en": "Más de la Poza Natural",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 618,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 450,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 3,
            "y_angle": -74,
            "distance": 7
          },
          "title": "Río",
          "title_en": "Río",
          "title_es": "Río",
          "sound_id": null,
          "image_id": "dsc-1456",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 461,
          "has_info": false,
          "info": "En las faldas del majestuoso Parque Nacional Rincón de la Vieja, se encuentra un lugar maravilloso que aún permanece desconocido para muchos. El denso bosque que lo rodea alberga una exuberante variedad de flora y fauna, contribuyendo a la belleza del paisaje. Este lugar tiene fines turísticos y culturales y es un punto de encuentro social y recreativo muy importante para la comunidad chilena. De hecho, forma parte de la historia y cultura local.\n",
          "info_es": "En las faldas del majestuoso Parque Nacional Rincón de la Vieja, se encuentra un lugar maravilloso que aún permanece desconocido para muchos. El denso bosque que lo rodea alberga una exuberante variedad de flora y fauna, contribuyendo a la belleza del paisaje. Este lugar tiene fines turísticos y culturales y es un punto de encuentro social y recreativo muy importante para la comunidad chilena. De hecho, forma parte de la historia y cultura local.\n",
          "info_en": "En las faldas del majestuoso Parque Nacional Rincón de la Vieja, se encuentra un lugar maravilloso que aún permanece desconocido para muchos. El denso bosque que lo rodea alberga una exuberante variedad de flora y fauna, contribuyendo a la belleza del paisaje. Este lugar tiene fines turísticos y culturales y es un punto de encuentro social y recreativo muy importante para la comunidad chilena. De hecho, forma parte de la historia y cultura local.\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 12,
            "y_angle": 24,
            "distance": 7
          },
          "title": " ",
          "title_en": " ",
          "title_es": " ",
          "sound_id": null,
          "image_id": "pozanatural",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 551,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "title": "Poza Gavilán",
          "title_en": "Poza Gavilán",
          "title_es": "Poza Gavilán",
          "sound_id": null,
          "image_id": null,
          "icon_id": "videoicon",
          "video_url": "https://www.youtube.com/watch?v=jAr-nJXdqbA"
        },
        {
          "id_tour_creator": 449,
          "has_info": false,
          "info": "La poza es una piscina natural creada por la erosión de las rocas y el flujo de agua del río que la alimenta. Es un lugar ideal para nadar y refrescarse en el agua fresca y cristalina rodeada de exuberante vegetación tropical.\nEl nombre \"Mapache\" proviene de la presencia de estos pequeños animales en la zona, que a menudo se les puede ver buscando comida y refrescándose en la poza. Además de disfrutar de la natación, los visitantes pueden observar la fauna y flora de la zona, incluyendo especies de aves y monos.",
          "info_es": "La poza es una piscina natural creada por la erosión de las rocas y el flujo de agua del río que la alimenta. Es un lugar ideal para nadar y refrescarse en el agua fresca y cristalina rodeada de exuberante vegetación tropical.\nEl nombre \"Mapache\" proviene de la presencia de estos pequeños animales en la zona, que a menudo se les puede ver buscando comida y refrescándose en la poza. Además de disfrutar de la natación, los visitantes pueden observar la fauna y flora de la zona, incluyendo especies de aves y monos.",
          "info_en": "La poza es una piscina natural creada por la erosión de las rocas y el flujo de agua del río que la alimenta. Es un lugar ideal para nadar y refrescarse en el agua fresca y cristalina rodeada de exuberante vegetación tropical.\nEl nombre \"Mapache\" proviene de la presencia de estos pequeños animales en la zona, que a menudo se les puede ver buscando comida y refrescándose en la poza. Además de disfrutar de la natación, los visitantes pueden observar la fauna y flora de la zona, incluyendo especies de aves y monos.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -10,
            "y_angle": 168,
            "distance": 7
          },
          "title": "Poza",
          "title_en": "Poza",
          "title_es": "Poza",
          "sound_id": null,
          "image_id": "dsc-1454-1",
          "icon_id": null,
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Poza Natural Mapache",
      "name_en": "Poza Natural Mapache",
      "lines": []
    }
  ],
  "assets": [
    {
      "id_tour_creator": 350,
      "img": [
        {
          "id": "foto1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/foto1.jpeg",
          "id_tour_creator": 1749
        },
        {
          "id": "dsc-4359-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_4359_Panorama_PanoramaFinal.jpg",
          "id_tour_creator": 1750
        },
        {
          "id": "foto2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/foto2.jpeg",
          "id_tour_creator": 1751
        },
        {
          "id": "pozanatural",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/pozaNatural.jpeg",
          "id_tour_creator": 1752
        },
        {
          "id": "foto3",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/foto3.jpeg",
          "id_tour_creator": 1753
        },
        {
          "id": "riozapote",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/RioZapote.jpeg",
          "id_tour_creator": 1754
        },
        {
          "id": "sensoria",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/sensoria.jpeg",
          "id_tour_creator": 1755
        },
        {
          "id": "foto4",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/foto4.jpeg",
          "id_tour_creator": 1756
        },
        {
          "id": "foto5",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/foto5.jpeg",
          "id_tour_creator": 1757
        },
        {
          "id": "foto6",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/foto6.jpeg",
          "id_tour_creator": 1758
        },
        {
          "id": "upalaguia",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/UpalaGuia.png",
          "id_tour_creator": 1760
        },
        {
          "id": "dsc-1181",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1181.jpg",
          "id_tour_creator": 1782
        },
        {
          "id": "img-20230120-062357-00-018-pureshot-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/IMG_20230120_062357_00_018_PureShot_PanoramaFinal.jpg",
          "id_tour_creator": 1783
        },
        {
          "id": "dsc-1390",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1390.jpg",
          "id_tour_creator": 1790
        },
        {
          "id": "dsc-1440",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1440.jpg",
          "id_tour_creator": 1791
        },
        {
          "id": "dsc-1416-1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1416_1.jpg",
          "id_tour_creator": 1792
        },
        {
          "id": "dsc-1454-1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1454_1.jpg",
          "id_tour_creator": 1793
        },
        {
          "id": "dsc-1456",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1456.jpg",
          "id_tour_creator": 1794
        },
        {
          "id": "dsc-1306",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1306.jpg",
          "id_tour_creator": 1795
        },
        {
          "id": "dsc-1302",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1302.jpg",
          "id_tour_creator": 1796
        },
        {
          "id": "dsc-1277",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1277.jpg",
          "id_tour_creator": 1797
        },
        {
          "id": "dsc-1312",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1312.jpg",
          "id_tour_creator": 1798
        },
        {
          "id": "dsc-1170-1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1170_1.jpg",
          "id_tour_creator": 1799
        },
        {
          "id": "dsc-1176",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1176.jpg",
          "id_tour_creator": 1800
        },
        {
          "id": "dsc-1167",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1167.jpg",
          "id_tour_creator": 1801
        },
        {
          "id": "dsc-4363-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_4363_Panorama_PanoramaFinal.jpg",
          "id_tour_creator": 1802
        },
        {
          "id": "dsc-4363-panorama-panoramafinal-12",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_4363_Panorama_PanoramaFinal_12.jpg",
          "id_tour_creator": 1803
        },
        {
          "id": "img-20230120-062658-00-019-pureshot-panoramafinal-1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/IMG_20230120_062658_00_019_PureShot_PanoramaFinal_1.jpg",
          "id_tour_creator": 1804
        },
        {
          "id": "dsc-4223-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_4223_Panorama_PanoramaFinal.jpg",
          "id_tour_creator": 1805
        },
        {
          "id": "img-20230120-064000-00-024-pureshot-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/IMG_20230120_064000_00_024_PureShot_PanoramaFinal.jpg",
          "id_tour_creator": 1806
        },
        {
          "id": "img-20230119-123649-00-011-pureshot-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/IMG_20230119_123649_00_011_PureShot_PanoramaFinal.jpg",
          "id_tour_creator": 1807
        },
        {
          "id": "img-20230119-123609-00-010-pureshot-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/IMG_20230119_123609_00_010_PureShot_PanoramaFinal.jpg",
          "id_tour_creator": 1818
        },
        {
          "id": "img-20230120-125102-00-042-pureshot-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/IMG_20230120_125102_00_042_PureShot_PanoramaFinal.jpg",
          "id_tour_creator": 1819
        },
        {
          "id": "informationtour",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/informationTour.png",
          "id_tour_creator": 1820
        },
        {
          "id": "videoicon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/videoIcon.png",
          "id_tour_creator": 1852
        },
        {
          "id": "dsc-1443",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1443.jpg",
          "id_tour_creator": 1877
        },
        {
          "id": "dsc-1146",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1146.jpg",
          "id_tour_creator": 1878
        },
        {
          "id": "dsc-1225",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/image/DSC_1225.jpg",
          "id_tour_creator": 1879
        }
      ],
      "sound": [
        {
          "id": "upala-souvenirs",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-souvenirs.mp3",
          "sound_type": "voice",
          "id_tour_creator": 641
        },
        {
          "id": "upala-souvenirs2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-souvenirs2.mp3",
          "sound_type": "voice",
          "id_tour_creator": 642
        },
        {
          "id": "upala-poza2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/upala-poza2.mp3",
          "sound_type": "voice",
          "id_tour_creator": 645
        },
        {
          "id": "upala-dosrios",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-dosrios.mp3",
          "sound_type": "voice",
          "id_tour_creator": 643
        },
        {
          "id": "viento_1_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/viento_1_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 587
        },
        {
          "id": "ambiente_pajaros_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/ambiente_pajaros_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 588
        },
        {
          "id": "persona_nadando_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/persona_nadando_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 589
        },
        {
          "id": "bosque_ambiente_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/bosque_ambiente_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 590
        },
        {
          "id": "ambiente_autos_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/ambiente_autos_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 591
        },
        {
          "id": "grillos_2_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/grillos_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 592
        },
        {
          "id": "souvenirs-u",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/souvenirs-U.mp3",
          "sound_type": "voice",
          "id_tour_creator": 593
        },
        {
          "id": "dosrios-u",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/dosrios-U.mp3",
          "sound_type": "voice",
          "id_tour_creator": 594
        },
        {
          "id": "cruce-u",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Cruce-U.mp3",
          "sound_type": "voice",
          "id_tour_creator": 595
        },
        {
          "id": "finca-u",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Finca-U.mp3",
          "sound_type": "voice",
          "id_tour_creator": 596
        },
        {
          "id": "fincaint-u",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/fincaInt-U.mp3",
          "sound_type": "voice",
          "id_tour_creator": 597
        },
        {
          "id": "cerrocacao-u",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/cerroCacao-U.mp3",
          "sound_type": "voice",
          "id_tour_creator": 598
        },
        {
          "id": "termales",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Termales.mp3",
          "sound_type": "voice",
          "id_tour_creator": 599
        },
        {
          "id": "restaurante",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Restaurante.mp3",
          "sound_type": "voice",
          "id_tour_creator": 614
        },
        {
          "id": "u-cerrosm",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-CerroSM.mp3",
          "sound_type": "voice",
          "id_tour_creator": 632
        },
        {
          "id": "u-fincan",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-fincaN.mp3",
          "sound_type": "voice",
          "id_tour_creator": 633
        },
        {
          "id": "u-fincaint",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-fincaInt.mp3",
          "sound_type": "voice",
          "id_tour_creator": 634
        },
        {
          "id": "u-cerrocacao",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-cerrocacao.mp3",
          "sound_type": "voice",
          "id_tour_creator": 635
        },
        {
          "id": "u-restaurante",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-restaurante.mp3",
          "sound_type": "voice",
          "id_tour_creator": 636
        },
        {
          "id": "u-souvenir",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-souvenir.mp3",
          "sound_type": "voice",
          "id_tour_creator": 637
        },
        {
          "id": "u-termales",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-termales.mp3",
          "sound_type": "voice",
          "id_tour_creator": 638
        },
        {
          "id": "u-cruce",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/u-cruce.mp3",
          "sound_type": "voice",
          "id_tour_creator": 639
        },
        {
          "id": "rio_1_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/rio01_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 640
        },
        {
          "id": "upala-poza1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-Poza1.mp3",
          "sound_type": "voice",
          "id_tour_creator": 644
        },
        {
          "id": "upala-restaurante",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-restaurante.mp3",
          "sound_type": "voice",
          "id_tour_creator": 646
        },
        {
          "id": "upala-finca",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-Finca.mp3",
          "sound_type": "voice",
          "id_tour_creator": 647
        },
        {
          "id": "upala-integral",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-Integral.mp3",
          "sound_type": "voice",
          "id_tour_creator": 648
        },
        {
          "id": "upala-santam",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-SantaM.mp3",
          "sound_type": "voice",
          "id_tour_creator": 649
        },
        {
          "id": "upala-cruce",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-Cruce.mp3",
          "sound_type": "voice",
          "id_tour_creator": 650
        },
        {
          "id": "upala-cacao",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Upala-Cacao.mp3",
          "sound_type": "voice",
          "id_tour_creator": 651
        },
        {
          "id": "multitud_hablando_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/multitud_hablando_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 691
        },
        {
          "id": "personas_bar_5_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/personas_bar_5_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 692
        },
        {
          "id": "viento",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/Viento_loop_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 693
        },
        {
          "id": "upala-poza2correccion",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-upala/sound/upala-poza2correccion.mp3",
          "sound_type": "voice",
          "id_tour_creator": 717
        }
      ],
      "video": []
    }
  ],
  "live_sessions": [],
  "tags": [],
  "description": "",
  "location": "",
  "banner": null,
  "link_google_maps": "",
  "thumbnail": null,
  "link_youtube": null,
  "page_guides": "http://",
  "price": 0
}
